import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { withNamespaces } from 'react-i18next';

import SweetAlert from 'react-bootstrap-sweetalert';
import { Card, CardBody, CardTitle, Col, Row, Badge } from 'reactstrap';
import { Th, Thead, Tr } from 'react-super-responsive-table';

import { getDmxControllers, deleteDmxController } from '../../store/actions';

class DmxControllerList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      user: JSON.parse(localStorage.getItem('authUser')),
      showConfirm: false,
      controllerToDelete: null,
      popup: false,
      pop_msg: '',
      alertType: '',
    };
  }

  componentDidUpdate(prevProps) {
    if (this.props.loadingDeleteDmxController === false && prevProps.loadingDeleteDmxController === true) {
      this.props.getDmxControllers(this.state.user);
      if (this.props.deleteDmxControllerError) {
        this.setState({
          popup: true,
          pop_msg: this.props.deleteDmxControllerError.message || 'Error al eliminar el controlador',
          alertType: 'error',
        });
      }
    }
  }

  confirmPopup() {
    this.setState({ popup: false });
  }

  confirmDelete(controller) {
    this.setState({ showConfirm: true, controllerToDelete: controller });
  }

  doDelete() {
    const { user, controllerToDelete } = this.state;
    this.props.deleteDmxController({ id: controllerToDelete.id, token: user.token });
    this.setState({ showConfirm: false });
  }

  render() {
    const { controllerList } = this.props;
    return (
      <Row>
        <Col>
          <Card>
            <CardBody>
              <CardTitle className="mb-4">{this.props.t('Controladores DMX')}</CardTitle>
              <div className="table-responsive">
                <table className="table table-centered table-nowrap mb-0">
                  <Thead>
                    <Tr>
                      <Th>{this.props.t('Nombre')}</Th>
                      <Th>{this.props.t('Ip')}</Th>
                      <Th>{this.props.t('Estado')}</Th>
                      <Th>{this.props.t('Actions')}</Th>
                    </Tr>
                  </Thead>
                  <tbody>
                    {controllerList.map((c) => (
                      <tr key={c.id}>
                        <td>
                          <span>{c.name}</span>
                        </td>
                        <td>
                          <span>{c.ip}</span>
                        </td>
                        <td>
                          <Badge
                            color={Number(c.active) === 1 ? 'success' : 'secondary'}
                            className={'badge-soft-' + (Number(c.active) === 1 ? 'success' : 'secondary') + ' font-size-13'}
                            pill
                          >
                            {this.props.t(Number(c.active) === 1 ? 'Activo' : 'Inactivo')}
                          </Badge>
                        </td>
                        <td>
                          <button
                            className="btn btn-primary waves-effect waves-light buttonStatus txtField"
                            title="Detalle"
                            onClick={() =>
                              this.props.history.push({
                                pathname: `/dmxControllerDetail/${c.id}`,
                                state: c,
                              })
                            }
                          >
                            <i className="mdi mdi-pencil font-size-14 align-middle"></i>
                          </button>
                          <button
                            className="btn btn-danger waves-effect waves-light buttonStatus txtField"
                            title="Eliminar"
                            onClick={() => this.confirmDelete(c)}
                          >
                            <i className="far fa-trash-alt font-size-14 align-middle"></i>
                          </button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </CardBody>
          </Card>
        </Col>
        {this.state.showConfirm ? (
          <SweetAlert
            showCancel
            title="¿Estás seguro?"
            cancelBtnBsStyle="danger"
            confirmBtnBsStyle="success"
            confirmBtnText={this.props.t('ok')}
            cancelBtnText={this.props.t('Cancel')}
            onConfirm={() => this.doDelete()}
            onCancel={() => this.setState({ showConfirm: false })}
          >
            {this.props.t('Solo se puede borrar un controlador sin universos asociados')}
          </SweetAlert>
        ) : null}
        {this.state.popup ? (
          <SweetAlert
            type={this.state.alertType === 'correct' ? 'success' : 'error'}
            confirmBtnBsStyle={this.state.alertType === 'correct' ? 'success' : 'danger'}
            title={this.state.pop_msg}
            confirmBtnText={this.props.t('ok')}
            onConfirm={() => this.confirmPopup()}
          ></SweetAlert>
        ) : null}
      </Row>
    );
  }
}

const mapStateToProps = (state) => {
  const { loadingDeleteDmxController, deleteDmxControllerError } = state.deleteDmxController;
  return { loadingDeleteDmxController, deleteDmxControllerError };
};

export default withRouter(
  connect(mapStateToProps, { getDmxControllers, deleteDmxController })(withNamespaces()(DmxControllerList)),
);
